import {ModuleWithProviders, NgModule} from '@angular/core';
import * as StorefrontApiClient from './storefront-api-client';

// @dynamic
export function CreateApiClientConfiguration(token: string, apiUrl: string, apiKey: string = 'ApiKey'): StorefrontApiClient.ApiClientConfiguration {
  const apiConf = new StorefrontApiClient.ApiClientConfiguration();
  apiConf.apiKey = apiKey;
  apiConf.apiUrl = apiUrl;
  apiConf.setAuthorizationToken(token);
  return apiConf;
}

@NgModule({
  declarations: [],
  imports: [
  ],
  exports: []
})
export class StorefrontModule {
  static forRoot(token: string, apiUrl: string, apiKey: string = 'ApiKey'): ModuleWithProviders<StorefrontModule> {
    return {
      ngModule: StorefrontModule,
      providers: [
        {
          provide: StorefrontApiClient.API_BASE_URL,
          useValue: apiUrl
        },
        {
          provide: StorefrontApiClient.ApiClientConfiguration,
          useFactory: CreateApiClientConfiguration.bind(this, token , apiUrl, apiKey)
        },
      ]
    };
  }
}
